<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      d="M8.85 14L8.55 12.5C8.35 12.4167 8.1625 12.3292 7.9875 12.2375C7.8125 12.1458 7.63333 12.0333 7.45 11.9L6 12.35L5 10.65L6.15 9.65C6.11667 9.41667 6.1 9.2 6.1 9C6.1 8.8 6.11667 8.58333 6.15 8.35L5 7.35L6 5.65L7.45 6.1C7.63333 5.96667 7.8125 5.85416 7.9875 5.7625C8.1625 5.67083 8.35 5.58333 8.55 5.5L8.85 4H10.85L11.15 5.5C11.35 5.58333 11.5375 5.675 11.7125 5.775C11.8875 5.875 12.0667 6 12.25 6.15L13.7 5.65L14.7 7.4L13.55 8.4C13.5833 8.6 13.6 8.80833 13.6 9.025C13.6 9.24167 13.5833 9.45 13.55 9.65L14.7 10.65L13.7 12.35L12.25 11.9C12.0667 12.0333 11.8875 12.1458 11.7125 12.2375C11.5375 12.3292 11.35 12.4167 11.15 12.5L10.85 14H8.85ZM9.85 11C10.4 11 10.8708 10.8042 11.2625 10.4125C11.6542 10.0208 11.85 9.55 11.85 9C11.85 8.45 11.6542 7.97917 11.2625 7.5875C10.8708 7.19583 10.4 7 9.85 7C9.3 7 8.82917 7.19583 8.4375 7.5875C8.04583 7.97917 7.85 8.45 7.85 9C7.85 9.55 8.04583 10.0208 8.4375 10.4125C8.82917 10.8042 9.3 11 9.85 11Z"
      fill="currentColor"
    />
    <path
      d="M2.94141 4.26659L5.67812 3.34802L3.51426 1.43725L2.94141 4.26659ZM12.7002 0.93978L12.7795 0.702715L12.7002 0.93978ZM4.59467 2.76873C4.94475 2.46496 5.32079 2.19039 5.71918 1.94845L5.45965 1.52109C5.03711 1.77769 4.63828 2.0689 4.26698 2.39107L4.59467 2.76873ZM5.71918 1.94845C6.74433 1.32589 7.89289 0.934344 9.08484 0.801083L9.02929 0.304179C7.7651 0.445517 6.54693 0.860797 5.45965 1.52109L5.71918 1.94845ZM9.08484 0.801083C10.2768 0.667822 11.4835 0.796054 12.6208 1.17685L12.7795 0.702715C11.5733 0.298845 10.2935 0.162841 9.02929 0.304179L9.08484 0.801083ZM12.6208 1.17685C13.7581 1.55764 14.7987 2.18183 15.6701 3.00593L16.0137 2.64266C15.0895 1.76861 13.9858 1.10658 12.7795 0.702715L12.6208 1.17685Z"
      fill="currentColor"
    />
    <path
      d="M17.0586 13.7334L14.3219 14.652L16.4857 16.5628L17.0586 13.7334ZM7.29984 17.0602L7.22046 17.2973L7.29984 17.0602ZM15.4053 15.2313C15.0552 15.535 14.6792 15.8096 14.2808 16.0515L14.5404 16.4789C14.9629 16.2223 15.3617 15.9311 15.733 15.6089L15.4053 15.2313ZM14.2808 16.0515C13.2557 16.6741 12.1071 17.0657 10.9152 17.1989L10.9707 17.6958C12.2349 17.5545 13.4531 17.1392 14.5404 16.4789L14.2808 16.0515ZM10.9152 17.1989C9.72321 17.3322 8.51653 17.2039 7.37921 16.8232L7.22046 17.2973C8.42671 17.7012 9.70652 17.8372 10.9707 17.6958L10.9152 17.1989ZM7.37921 16.8232C6.24189 16.4424 5.20127 15.8182 4.32985 14.9941L3.9863 15.3573C4.91052 16.2314 6.01421 16.8934 7.22046 17.2973L7.37921 16.8232Z"
      fill="currentColor"
    />
    <path
      d="M3.78489 3.20151C4.55986 2.37086 5.49348 1.70399 6.53056 1.2403C7.56765 0.776605 8.68717 0.525508 9.82295 0.501845C10.9587 0.478182 12.0877 0.682433 13.1432 1.10253C14.1987 1.52262 15.1593 2.15003 15.9682 2.94769"
      stroke="currentColor"
    />
    <path
      d="M16.2151 14.7985C15.4401 15.6291 14.5065 16.296 13.4694 16.7597C12.4323 17.2234 11.3128 17.4745 10.177 17.4982C9.04127 17.5218 7.91227 17.3176 6.85677 16.8975C5.80127 16.4774 4.84069 15.85 4.03179 15.0523"
      stroke="currentColor"
    />
    <path
      d="M2.83845 14.0274C2.00819 12.8447 1.48377 11.4748 1.31202 10.04C1.14027 8.60516 1.32655 7.15016 1.85421 5.80491"
      stroke="currentColor"
      stroke-width="0.5"
      stroke-linecap="square"
      stroke-dasharray="1.5 2"
    />
    <path
      d="M17.1616 3.97261C17.9918 5.15532 18.5162 6.52525 18.688 7.96004C18.8597 9.39484 18.6735 10.8498 18.1458 12.1951"
      stroke="currentColor"
      stroke-width="0.5"
      stroke-linecap="square"
      stroke-dasharray="1.5 2"
    />
  </svg>
</template>

<script>
export default {
  name: "ReviewProcessingIcon"
};
</script>
